export default "__VITE_ASSET__a1f34371__"